// extracted by mini-css-extract-plugin
export default {"wc":"wc","hidden":"hidden","wc_video":"wc_video"};